export default __webpack_public_path__ + "static/media/typing.f55255b7.gif";